const maisVendasUrl = 'https://maisvendas.somalabs.com.br/login';

export { maisVendasUrl };
